// extracted by mini-css-extract-plugin
export default {"container":"OpeningHour_container__81nr1","contain":"OpeningHour_contain__OoGWr"};